import { z } from 'zod';
import {
  DEFAULT_GENERATION_MODEL_KEY,
  GENERATION_MODEL_CATALOG,
  GENERATION_MODEL_EFFORTS,
  GENERATION_MODEL_KEYS,
  GENERATION_MODEL_PROVIDERS,
  type GenerationModelKey,
} from '../constants.js';

export const GenerationModelKeySchema = z.enum(GENERATION_MODEL_KEYS);
export const GenerationModelProviderSchema = z.enum(GENERATION_MODEL_PROVIDERS);
export const GenerationModelEffortSchema = z.enum(GENERATION_MODEL_EFFORTS);

export const SafeGenerationModelMetadataSchema = z.object({
  key: GenerationModelKeySchema,
  label: z.string().min(1),
  provider: GenerationModelProviderSchema,
  providerLabel: z.string().min(1),
  providerModelId: z.string().min(1).nullable(),
  effort: GenerationModelEffortSchema,
  effortLabel: z.string().min(1),
});
export type SafeGenerationModelMetadata = z.infer<typeof SafeGenerationModelMetadataSchema>;

export const DEFAULT_GENERATION_MODEL_METADATA =
  GENERATION_MODEL_CATALOG[DEFAULT_GENERATION_MODEL_KEY];

export function getGenerationModelMetadata(key: GenerationModelKey): SafeGenerationModelMetadata {
  return GENERATION_MODEL_CATALOG[key];
}
